import Select from 'react-select'
import {useTranslation} from 'react-i18next';
import { FC, useEffect, useState } from 'react';
import FormGateway from '../../../gateway/Form/FormGateway';

export interface ISelectFormProps {
  onSelectChange: (formId: string|null) => void;
}

const SelectForm: FC<ISelectFormProps> = ({onSelectChange}) => {
  const {t} = useTranslation()
  const [formOptions, setFormOptions] = useState<{ value: string; label: string; }[]>([{ value: 'all', label: 'Toutes les souscriptions' }])

  useEffect(() => {
    new FormGateway().getForms().then(forms => {
      if (null !== forms) {
        const transformedArray = forms.map(item => ({
          value: item.id,
          label: item.label,
        }));
        setFormOptions([...formOptions, ...transformedArray])
      }
    })
  }, [])

  return (
    <>
      {formOptions.length > 1 && (
        <Select
          menuPosition="absolute"
          menuPortalTarget={document.body}
          placeholder={t('common.select-placeholder')}
          options={formOptions}
          defaultValue={formOptions[0]}
          isMulti={false}
          isClearable={false}
          onChange={val => {
            onSelectChange(val.value !== 'all' ? val.value : null)
          }}
        />
      )}
    </>
  )
};

export default SelectForm;
